import Reveal from "../components/Reveal";
import VideoCard from "../components/VideoCard";
import QuoteForm from "../components/QuoteForm";
import ClientMarquee from "../components/ClientMarquee";
import SEO from "../components/SEO";
import { serviceJsonLd } from "../data/seo";
import { ANIMATION } from "../data/content";

const SHOWREEL_VIDEO = {
  id: "468864496",
  h: "0f49e04819",
  title: "Yellow Animation Showreel",
  client: "Yellow Video Production",
};

// Static image cards (replacing the in-card videos for the 3 reels).
const STILLS = {
  "195550505": "/animation/2d-motion-graphics-animation-liverpool.jpg",
  "286331479": "/animation/3d-rendering-animation-liverpool.jpg",
  "468864496": "/animation/explainer-infographic-animation-liverpool.jpg",
};

const STILL_ALT = {
  "195550505": "2D motion graphics animation Liverpool by Yellow Video Production",
  "286331479": "3D rendering animation Liverpool, warehouse forklift visualisation by Yellow",
  "468864496": "Explainer animation and infographic Liverpool, app onboarding by Yellow",
};

export default function Animation() {
  return (
    <main className="pt-28 pb-12" data-testid="animation-page">
      <SEO
        title="Animation Company Liverpool | Motion Graphics & 3D | Yellow"
        description="Liverpool animation studio creating 2D motion graphics, 3D visualisations & explainer videos. Any budget, any deadline, UK-wide delivery. Fixed quote within 4 hours."
        path="/animation-liverpool"
        keywords="animation liverpool, animation company liverpool, motion graphics liverpool, 2d animation liverpool, 3d animation liverpool, explainer video liverpool, animated video liverpool, motion design liverpool"
        jsonLd={serviceJsonLd({
          name: "Animation Liverpool",
          description:
            "Animation company in Liverpool, 2D motion graphics, 3D visualisations and explainer animations for promotional, educational and instructional content.",
          path: "/animation-liverpool",
        })}
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Animation", path: "/animation-liverpool" },
        ]}
      />
      <section className="yv-container">
        <Reveal>
          <p className="yv-eyebrow">Animation Company Liverpool</p>
          <h1 className="yv-h1 mt-3 max-w-5xl">
            <span style={{ color: "var(--yellow)" }}>Animation, motion graphics and 3D visualisations.</span>
            <br />
            Any budget. Any deadline.
          </h1>
          <p className="text-white/70 max-w-3xl mt-6 text-lg leading-relaxed">
            Yellow is an <strong className="text-white">animation company in Liverpool</strong> producing 2D motion graphics, 3D renderings and explainer animations for promotional, educational, entertainment or instructional purposes, whatever your budget, send us a brief and we'll produce a high-quality animation that suits your requirements.
          </p>
        </Reveal>
      </section>

      {/* Big animation showreel */}
      <section className="yv-container !mt-16">
        <Reveal>
          <div className="max-w-5xl mx-auto">
            <VideoCard video={SHOWREEL_VIDEO} size="lg" testId="anim-showreel-card" />
          </div>
        </Reveal>
      </section>

      {/* Three reel cards with static images (no video on these) */}
      <section className="yv-container !mt-16 grid lg:grid-cols-3 gap-6">
        {ANIMATION.reels.map((r, i) => (
          <Reveal key={r.id} delay={i * 100}>
            <article className="bg-white/[0.02] border border-white/10 rounded-md overflow-hidden h-full" data-testid={`anim-card-${r.id}`}>
              <div className="aspect-[16/9] overflow-hidden bg-black">
                <img
                  src={STILLS[r.id]}
                  alt={STILL_ALT[r.id]}
                  loading="lazy"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <h3 className="yv-h3 text-white mb-2">{r.title}</h3>
                <p className="text-white/65 text-sm leading-relaxed">{r.body}</p>
              </div>
            </article>
          </Reveal>
        ))}
      </section>

      <ClientMarquee />

      <section className="yv-container !mt-20 max-w-2xl mx-auto">
        <Reveal>
          <QuoteForm heading="Let us know your requirements, quote within 4 hours" />
        </Reveal>
      </section>
    </main>
  );
}
